<template>
  <div class="page">
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="门店名称">
        <el-input style='width: 177px;' v-model="queryForm.storeName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopStore">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopStore(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopStore(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopStoreList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopStoreList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="storeName" label="门店名称" width="180">
        </el-table-column> -->
        <el-table-column align="center" prop="storeLogo" label="门店信息" min-width="300" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div v-if='scope.row.storeLogo' style="display: flex;justify-content: center;align-items: center;">
              <el-image @click='updateSrcList(scope.row.storeLogo)' style="width: 60px; height: 60px"
                :src="scope.row.storeLogo" :preview-src-list="srcList"> </el-image>
                <div style="flex:auto;text-align: center;margin-left: 4px;">
                  <div>{{ scope.row.storeName }}</div>
                  <div :style="{'fontSize':'12px',color:scope.row.openStatus == 1 ? 'green':'red'}">({{ scope.row.openStatus == 1 ? '正常营业' : '暂停营业' }})</div>
                  <div>{{ scope.row.openHours }}</div>
                  <div>收益比列：{{ scope.row.incomeRatio }}</div>
                </div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="storeAddress" label="地址" min-width="300">
          <template slot-scope="scope">
            <div v-if='scope.row.storeAddress'>
              <div style="text-align: left;">区域:{{ scope.row.province.areaName }}{{ scope.row.city.areaName }}{{ scope.row.area.areaName }}</div>
              <div style="text-align: left;overflow:hidden;text-overflow: ellipsis;">详细地址:{{ scope.row.storeAddress }}</div>
            </div>

            <div v-else>--</div>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="province.areaName" label="所属省份" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="city.areaName" label="所属城市" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="area.areaName" label="所属区县" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="storeAddress" label="门店位置" width="180">
        </el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="storePosition" label="门店定位" width="180">
        </el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="openStatus" label="营业状态" width="180">
          <template slot-scope='scope'>
            <el-tag :type='scope.row.openStatus == 1 ? "success" : "danger"'>{{ scope.row.openStatus == 1 ? '正常运营' : '暂停营业' }}</el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="openHours" label="营业时间" width="180">
        </el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系姓名" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPhone" label="联系电话" width="180">
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系人" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contactPerson">
                <div style="text-align: left">联系姓名:{{ scope.row.contactPerson }}</div>
                <div style="text-align: left">联系电话:{{ scope.row.contactPhone }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="门店管理" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
                <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip='true'
            align='center'
            prop='status'
            label='审核状态'
            width='180'
        >
            <template slot-scope="scope">
                <div>{{ computeAuditStatus(scope.row.status) }}</div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="410">
          <template slot-scope="scop">
            <div class="operation">
              <div @click='ShopStoreAudit(scop.row)' v-if='scop.row.status == 1'>
                <el-button type='primary' size='small'>审核</el-button>
              </div>
              <div @click="openList(scop.row.id)">
                    <i class="el-icon-folder-opened" size="16"></i>
                    <span class="operation-label">管理商品</span>
              </div>
              <div @click="openShop(scop.row.id)">
                  <i class="el-icon-circle-plus-outline" size="16"></i>
                  <span class="operation-label">添加商品</span>
              </div>
              <div @click="checkShopStore(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopStore(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopStore(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopStoreStates[shopStoreState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
        <div>
          <el-form :model="shopStore" ref="shopStoreForm" :rules="rules" label-width="120px" :inline="true" size="small">
            <el-form-item label="门店名称" prop="storeName">
              <el-input style='width: 177px;' size="small" v-model="shopStore.storeName" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="收益比例" prop="incomeRatio">
              <el-input style='width: 177px;' size="small" v-model="shopStore.incomeRatio" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="门店位置" prop="storeAddress">
              <location
                style='width: 177px;'
                :areaTreeDate="areaTreeDate"
                :longitude="shopStore.storePosition.split(',')[0]"
                :latitude="shopStore.storePosition.split(',')[1]"
                :provinceId="shopStore.provinceId"
                :cityId="shopStore.cityId"
                :areaId="shopStore.areaId"
                :address="shopStore.storeAddress"
                :disabled="shopStoreState == 'check'"
                @getLocation="getLocation"
              ></location>
            </el-form-item>
            <el-form-item label="所属省份" prop="provinceId">
              <!-- <el-input size="small" v-model="shopStore.provinceId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                placeholder='请选择省'
                @change="clearSubitem('province')"
                clearable
                style='width: 177px'
                size='small'
                v-model='shopStore.provinceId'
                :disabled="shopStoreState == 'check'"
              >
                <el-option
                  v-for='(item,index) in provinceArry'
                  :key='index'
                  :label='item.areaName'
                  :value='item.id'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属城市" prop="cityId">
              <!-- <el-input size="small" v-model="shopStore.cityId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                  placeholder='请选择市'
                  @change="clearSubitem('city')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='shopStore.cityId'
                  :disabled="shopStoreState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in cityArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属区县" prop="areaId">
              <!-- <el-input size="small" v-model="shopStore.areaId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                    placeholder='请选择区县'
                    clearable
                    style='width: 177px'
                    size='small'
                    v-model='shopStore.areaId'
                    :disabled="shopStoreState == 'check'"
                >
                    <el-option
                        v-for='(item,index) in areaArry'
                        :key='index'
                        :label='item.areaName'
                        :value='item.id'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="门店定位" prop="storePosition">
              <el-input style='width: 177px;' size="small" v-model="shopStore.storePosition" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <!-- <el-form-item label="经度" prop="longitude">
              <el-input size="small" v-model="shopStore.longitude" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
              <el-input size="small" v-model="shopStore.latitude" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item> -->
            <el-form-item label="营业状态" prop="openStatus">
              <!-- <el-input size="small" v-model="shopStore.openStatus" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select placeholder="请选择状态" :disabled="shopStoreState == 'check'" clearable style="width: 177px"
                size="small" v-model="shopStore.openStatus">
                <el-option v-for='(item, index) in productStatusEnumList' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="营业时间" prop="openHours">
              <!-- <el-input size="small" v-model="shopStore.openHours" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-time-picker
                  :disabled="shopStoreState == 'check'"
                  is-range
                  style="width: 177px;"
                  v-model="shopStore.openHours"
                  range-separator="至"
                  format='HH:mm:ss'
                  value-format='HH:mm:ss'
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="联系姓名" prop="contactPerson">
              <el-input style='width: 177px;' size="small" v-model="shopStore.contactPerson" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input style='width: 177px;' size="small" v-model="shopStore.contactPhone" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="门店备注" prop="remarks">
              <el-input style='width: 177px;' size="small" v-model="shopStore.remarks" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="门店管理" prop="userId">
              <!-- <el-input size="small" v-model="shopStore.userId" :disabled="shopStoreState == 'check'"></el-input> -->
              <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName" :disabled="shopStoreState == 'check'"
                labelValue="id" :value="shopStore.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item label="门店推广" prop="promoterId">
              <GridSelectLi
                :disabled="shopStoreState == 'check'"
                style="width: 177px"
                title="选择推广人"
                labelName="promoterName"
                labelValue="id"
                :did="did"
                :value="shopStore.promoterId"
                :limit="1"
                size="small"
                placeholder="请选择商品"
                @getValue="getSeachValuebrandId"
                :columns="PROMOTER_code"
                :searchs="PROMOTER_search"
                dataListUrl="/mpp/promoter/findList"
                entityBeanName="mppPromoter"
                queryEntityUrl="/mpp/promoter/get"
              >
              </GridSelectLi>
            </el-form-item>
            <el-form-item label="门店配送" prop="deliverId">
              <GridSelectLi
                :disabled="shopStoreState == 'check'"
                style="width: 177px"
                title="选择配送员"
                labelName="personName"
                labelValue="id"
                :did="did"
                :value="shopStore.deliverId"
                :limit="1"
                size="small"
                placeholder="请选择配送人"
                @getValue="getSeachValuepersonId"
                :columns="PERSON_code"
                :searchs="PERSON_search"
                dataListUrl="/washcloud/deliver/findList"
                entityBeanName="shopDeliver"
                queryEntityUrl="/washcloud/deliver/get"
              >
                  </GridSelectLi>
            </el-form-item>
            <el-form-item label="门店分拣" prop="sortingId">
              <!-- <el-select placeholder="请选择" :disabled="shopStoreState == 'check'" clearable style="width: 177px"
                size="small" v-model="shopStore.sortingId">
                <el-option v-for='(item, index) in sortingList' :key='index' :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select> -->
              <GridSelectLi
                :disabled="shopStoreState == 'check'"
                style="width: 177px"
                title="选择分拣员"
                labelName="personName"
                labelValue="id"
                :did="did"
                :value="shopStore.sortingId"
                :limit="1"
                size="small"
                placeholder="请选择分拣人"
                @getValue="getSeachValuepersonId1"
                :columns="SORTING_code"
                :searchs="SoRTING_search"
                dataListUrl="/washcloud/sorting/findList"
                entityBeanName="shopSorting"
                queryEntityUrl="/washcloud/sorting/get"
              >
                  </GridSelectLi>
            </el-form-item>
              <el-form-item label="前台展示" prop="isShow">
                  <!-- <el-input size="small" v-model="shopStore.openStatus" :disabled="shopStoreState == 'check'"></el-input> -->
                  <el-select placeholder="请选择状态" :disabled="shopStoreState == 'check'" clearable style="width: 177px"
                             size="small" v-model="shopStore.isShow">
                      <el-option label="展示" :value="1">
                      </el-option>
                      <el-option label="隐藏" :value="0">
                      </el-option>
                  </el-select>
              </el-form-item>
            <el-form-item label="门店Logo" prop="storeLogo">
              <!-- <el-input size="small" v-model="shopStore.storePic" :disabled="shopStoreState == 'check'"></el-input>  -->
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                :disabled="shopStoreState == 'check'" class="avatar-uploader" :show-file-list="false"
                :http-request="uploadImage">
                <img v-if="shopStore.storeLogo" :src="shopStore.storeLogo" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
              <el-form-item label="门头照片" prop="storeBanner">
                  <!-- <el-input size="small" v-model="shopStore.storePic" :disabled="shopStoreState == 'check'"></el-input>  -->
                  <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                             :disabled="shopStoreState == 'check'" class="avatar-uploader" :show-file-list="false"
                             :http-request="uploadImage1">
                      <img v-if="shopStore.storeBanner" :src="shopStore.storeBanner" class="avatar" size="small" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
              </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopStoreState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!--审核功能-->
    <el-dialog title='门店申请审核' :visible.sync='retreatDialogVisible' width='30%' :before-close='handleCloseRetreat'>
      <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
          <el-form-item label='申请说明：'>
              <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                        :disabled='true'></el-input>
          </el-form-item>
          <el-form-item label='是否同意：' prop='resource'>
              <el-radio-group v-model='retreatForm.resource'>
                  <el-radio label='true'>同意</el-radio>
                  <el-radio label='false'>拒绝</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label='拒绝原因：' v-if="retreatForm.resource == 'false'" prop='desc'>
              <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
          </el-form-item>
          <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>
              <el-input style='width: 177px' v-model='retreatForm.incomeRatio'></el-input>
          </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='handleCloseRetreat'>取 消</el-button>
        <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加商品 -->
    <el-dialog title="添加商品" :visible.sync="showAdd" width="400px" @close="closeShop">
        <div>
            <el-form :model="shopProductClassify" ref="shopProductClassifyForm" :rules="ruless" :inline="true" size="small">
                <el-form-item label="商品" prop="productIdList">
                    <div style="display: flex;">
                      <GridSelectLi
                        ref="add1"
                        style="width: 250px;"
                        title="选择商品"
                        labelName="productName"
                        labelValue="id"
                        :did="did"
                        :value="shopProductClassify.productIdList"
                        :limit="99"
                        size="small"
                        placeholder="请选择商品"
                        @getValue="getValuebrandId"
                        :columns="PRODUCT_code"
                        :searchs="PRODUCT_search"
                        dataListUrl="/washcloud/product/findList"
                        entityBeanName="shopProduct"
                        queryEntityUrl="/washcloud/product/get"
                    >
                    </GridSelectLi>
                    <el-button style="height: 30px;margin: 0 4px;" type="primary" @click="add1">添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="分类" prop="categoryId">
                  <el-select placeholder="请选择状态" clearable style="width: 250px"
                    size="small" v-model="shopProductClassify.categoryId">
                    <el-option v-for='(item, index) in productStatusEnumList1' :key='index' :label="item.categoryName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

            </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
            <el-button @click="closeShop">关闭</el-button>
            <el-button type="primary" @click="shopaddForm">确定</el-button>
        </div>
    </el-dialog>


    <!-- 弹窗商品列表 -->
    <el-dialog title="商品列表" :visible.sync="shopList" width="1200px">
        <!-- <shop-product-catalog-list :id="this.shopListForm.activityId"></washcloud-product-catalog-list> -->
        <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopProductClassify(null)"
        >删除</el-button
        >
        <el-table
            :data="shopProductClassifyList"
            row-key="id"
            border
            @selection-change="handleSelectionChange"
            height="500px"
            size="small"
        >
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="商品" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.product">
              <div style='text-align: left'>名称：{{ scope.row.product.productName }}</div>
              <div style='text-align: left'>货号：{{ scope.row.product.productNumber }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
		<el-table-column :show-overflow-tooltip="true" align="center" prop="product.productPic" label="商品图片" width="180">
		  <template slot-scope="scope">
		    <div v-if='scope.row.product.productPic'>
		      <el-image @click='updateSrcList(scope.row.product.productPic)' style="width: 60px; height: 60px"
		        :src="scope.row.product.productPic" :preview-src-list="srcList"> </el-image>
		      </div>
		    <div v-else>--</div>
		  </template>
		</el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="价格" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.product">
              <div style='text-align: left'>商品价格：{{ scope.row.product.shopPrice }}</div>
              <div style='text-align: left'>市场价格：{{ scope.row.product.marketPrice }}</div>
              <div style='text-align: left'>供货价格：{{ scope.row.product.supplyPrice }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="category.categoryName" label="所属分类" width="180">
        </el-table-column>
        
        <el-table-column :show-overflow-tooltip="true" align="center" prop="store.storeName" label="门店名称" width="180">
        </el-table-column>
            <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="更新时间"> </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="200">
                <template slot-scope="scop">
                    <div class="operation">
                        <!-- <div @click="update(scop.row.id)">
                            <i class="el-icon-refresh"></i>
                            <span class="operation-label" style="color: #409eff">更新</span>
                        </div> -->
                        <div @click="deleteShopProductClassify(scop.row.id)">
                            <Icon size="16" style="color: red">
                                <Delete24Regular />
                            </Icon>

                            <span class="operation-label" style="color: red">删除</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                @size-change="sizeChanges"
                @current-change="currentChanges"
                :current-page.sync="currentPages"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSizes"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNums"
                background
                :pager-count="7"
            >
            </el-pagination>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import Location from '@/components/location/location.vue';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT1, PRODUCT_SEARCH1, USER_SEARCH, PROMOTER, PROMOTER_SEARCH, PERSON, PERSON_SEARCH, SORTING, SORTING_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
import GridSelectLi from '@/components/gridselect/gidselect.vue';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    Location,
    GridSelectU,
    GridSelectLi
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetShopStoreList();
        this.getShopStoreList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetShopStoreList();
        this.getShopStoreList();
        this.$emit('resetCheckState');
      }
    }
  },
  computed: {
    provinceArry() {
        return this.areaTreeDate;
    },
    cityArry() {
      if (!this.provinceArry) {
        return [];
      } else {
        for (let i = 0; i < this.provinceArry.length; i++) {
          if (this.provinceArry[i].id == this.shopStore.provinceId) {
            return this.provinceArry[i].children;
          } else if (this.shopStore.provinceId == '') {
            return [];
          }
        }
      }
    },
    areaArry() {
      if (!this.cityArry) {
        return [];
      } else {
        for (let i = 0; i < this.cityArry.length; i++) {
          if (this.cityArry[i].id == this.shopStore.cityId) {
              return this.cityArry[i].children;
          }
        }
      }
    }
  },
  data() {
    return {
      shopProductClassifyList: [],
      shopList: false,
      totalNums:0,
      cid:"",
      currentPages: 1,
      pageSizes:10,
      shopListForm: {
          storeId: '',
          productName: '', //商品id
          activityName: '' //类别类型
      },


      sortingList: [],
      shopProductClassify: {
          id: '', //id
          productIdList: [], //商品id
          storeId: '', //类别类型
          categoryId:''
      },
      showAdd: false,
      PRODUCT_code: PRODUCT1,
      PRODUCT_search: PRODUCT_SEARCH1,
      did:'',

      USER_code: USER,
      USER_search: USER_SEARCH,
      PROMOTER_code: PROMOTER,
      PROMOTER_search: PROMOTER_SEARCH,
      PERSON_code: PERSON,
      PERSON_search: PERSON_SEARCH,
      SORTING_code: SORTING,
      SoRTING_search: SORTING_SEARCH,
      queryForm: {
        id: '', //ID
        storeName: '', //门店名称
        storeLogo: '', //门店图片
        provinceId: '', //省
        cityId: '', //市
        areaId: '', //区
        storeAddress: '', //详细地址
        storePosition: '', //定位
        longitude: '', //经度
        latitude: '', //纬度
        openStatus: '', //营业状态
        openHours: '', //营业时间
        contactPerson: '', //联系人姓名
        contactPhone: '', //联系人电话
        remarks: '', //备注
        userId: '', //店铺管理
        createTime: '', //创建时间
      },
      header: {
        token: localStorage.getItem('token')
      },
      action: UPLOAD_API + UPLOAD_PATH,
      areaTreeDate:[],
      srcList: [''],
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      shopStoreState: 'add',
      shopStoreStates: {
        add: '新建门店',
        check: '查看门店',
        edit: '修改门店'
      },

      multipleSelection: [],
      shopStoreList: [],
      shopStore: {
        storeName: '', //门店名称
        incomeRatio: '',
        storeLogo: '', //门店图片
        provinceId: '', //省
        cityId: '', //市
        areaId: '', //区
        storeAddress: '', //详细地址
        storePosition: '', //定位
        longitude: '', //经度
        latitude: '', //纬度
        openStatus: '', //营业状态
        openHours: ['08:00:00','20:00:00'], //营业时间
        contactPerson: '', //联系人姓名
        contactPhone: '', //联系人电话
        remarks: '', //备注
        userId: '', //店铺管理
        promoterId:"",
        personId:"",
        deliverId:"",
        sortingId: '',
          storeBanner: '',
          isShow: 1,
      },
      btnLoading: false,
      productStatusEnumList:[],
      productStatusEnumList1:[],
      ruless:{
        productIdList: [{ required: true, message: '商品不能为空', trigger: 'blur' }],
        categoryId: [{ required: true, message: '类别不能为空', trigger: 'blur' }],
      },
      rules: {
        storeName: [{ required: true, message: '门店名称不能为空', trigger: 'blur' }],
        incomeRatio: [{ required: true, message: '收益比例不能为空', trigger: 'blur' }],
        storeLogo: [{ required: true, message: '门店图片不能为空', trigger: 'blur' }],
        provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
        cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
        areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
        storeAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
        storePosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
        longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
        latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
        openStatus: [{ required: true, message: '营业状态不能为空', trigger: 'blur' }],
        openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '联系人电话不能为空', trigger: 'blur' }],
        userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
        promoterId: [{ required: true, message: '推广人不能为空', trigger: 'blur' }],
        deliverId: [{ required: true, message: '配送人不能为空', trigger: 'blur' }],
        sortingId: [{ required: true, message: '门店分拣不能为空', trigger: 'blur' }],
        storeBanner: [{ required: true, message: '门头照片不能为空', trigger: 'blur' }],
        isShow: [{ required: true, message: '前台展示不能为空', trigger: 'blur' }],
      },
      auditId:'',
      retreatDialogVisible:false,
      applyRemarks:'',
      retreatRules: {
          resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
          desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
          incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }]
      },
      retreatForm: {
          resource: '',
          desc: '',
          incomeRatio: ''
      },
      auditStatus:[],
    };
  },
  created() {
    this.getTreeData();
    this.getShopStoreList();
    this.getProductStatusEnum();
    this.getAuditStatus();
    this.getProductStatusEnum1();
    this.getsortingList();
  },
  methods: {
    //更新
    // update(id) {
    //     post(`shop/activityproduct/updateCreateTime`, { id }).then((res) => {
    //         if (res.success) {
    //             this.$message({
    //                 message: res.msg,
    //                 type: 'success',
    //                 duration: 2000
    //             });
    //         }
    //         this.openList(this.cid);
    //     });
    // },
    //删除
    add1(){
      this.$refs.add1.showSelectDialog();
      console.log(this.$refs.add1)
    },
    getsortingList(){
      get('/washcloud/sorting/findAll').then((res)=>{
        if(res.success){
          this.sortingList = res.list
        }
      })
    },
    deleteShopProductClassify(shopProductClassifyId) {
        let ids = '';
        if (shopProductClassifyId) {
            ids = shopProductClassifyId;
        } else {
            ids = this.multipleSelection.map((shopProductClassify) => shopProductClassify.id).join(',');
        }
        console.log({ ids });
        this.$confirm('确定删除所选项吗？', '提示', {
            type: 'warning'
        })
            .then(() => {
                deleteFun(`/washcloud/storeproduct/delete`, { ids }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                        console.log(this.cid);
                        this.openList(this.cid);
                    }
                });
            })
            .catch(() => {});
    },
    //商品列表
    openList(id) {
        this.shopProductClassifyList = [];
        this.shopList = true;
        this.loading = true;
        this.shopListForm.storeId = id;
        console.log(this.shopListForm)
        get(`/washcloud/storeproduct/findList`, {
            ...this.shopListForm,
            pageNum: this.currentPages,
            pageSize: this.pageSizes
        }).then((res) => {
            this.loading = false;
            if (res.success) {
                console.log(res.page.list);
                this.totalNums = 0;
                this.shopProductClassifyList = res.page.list;
                this.cid = this.shopProductClassifyList[0].storeId;
                this.totalNums = res.page.total;
            }
        });
    },





    getValuebrandId(value) {
        console.log('1111111111111111111111111111111111111111111')
        this.shopProductClassify.productIdList = value;

        // console.log('1111111',this.shopProductClassify.productIdList)
        // console.log('2222222',this.shopProductClassify.productId)
    },
    closeShop() {
        this.shopProductClassify = {
            // id: '', //id
            productId: [], //商品id
            activityId: '' //类别类型
        };
        this.$refs.shopProductClassifyForm.resetFields();
        this.showAdd = false;
    },
    //添加商品信息
    openShop(id) {
        this.showAdd = true;
        console.log(id);
        this.shopProductClassify.storeId = id;
        this.did = id;
        console.log(this.did);
        console.log(this.shopProductClassify);
    },
    shopaddForm() {
        this.$refs.shopProductClassifyForm.validate((valid) => {
            if (valid) {
                console.log('submit');
                console.log(this.shopProductClassify);
                post(`/washcloud/storeproduct/addBatch`, { ...this.shopProductClassify }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                        this.closeShop();
                    }else{
						this.$message({
						    message: res.msg,
						    type: 'error',
						    duration: 2000
						});
					}
                });
            }
        });
    },






    getSeachValuepersonId(val){
      console.log(val)
      this.shopStore.deliverId = val;
      // console.log( this.shopStore)
    },
    getSeachValuepersonId1(val){
      console.log(val)
      this.shopStore.sortingId = val;
      // console.log( this.shopStore)
    },
    // 计算AuditStatus
    computeAuditStatus(type){
            for (let i = 0; i < this.auditStatus.length; i++) {
                if(this.auditStatus[i].key == type){
                    return this.auditStatus[i].value
                }
            }
        },
    // 获取AuditStatusEnum枚举
    getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
    //
    ShopStoreAudit(item) {
        console.log('applyRemarks',item)
        this.retreatDialogVisible = true;
        this.auditId = item.id;
        this.applyRemarks = item.remarks;
        this.retreatDialogVisible = true;
    },

    // 审核取消按钮
    handleCloseRetreat() {
        this.retreatDialogVisible = false;
        this.auditId = '';//关闭后清除点击的id
        this.applyRemarks = ''; //关闭后清除申请人的说明
        this.retreatForm.resource = '';//关闭后把选择的按钮置空
        this.retreatForm.desc = ''
        this.retreatForm.incomeRatio = ''
    },

    //审核确认按钮
    retreatSuccess(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                //处理选择同意&拒绝
                let status = 1;
                this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                this.retreatDialogVisible = false;
                get(`/washcloud/store/auditStore`, {
                    id: this.auditId,
                    status: status,
                    refuseReason: this.retreatForm.desc,
                    incomeRatio: this.retreatForm.incomeRatio
                }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                        this.handleCloseRetreat()
                        this.getShopStoreList();
                    }
                });
            }
        });
    },
    getSeachValuebrandId(val){
      this.shopStore.promoterId = val
      console.log(this.shopStore)
    },
    // 获取商品状态枚举
    getProductStatusEnum() {
      get('/mpp/utils/getEnum', {
        enumType: 'opening_status',
      }).then((res) => {
        if (res.success) {
          this.productStatusEnumList = res.enumList
          console.log(this.productStatusEnumList)
        }
      })
    },
    // 获取商品状态枚举
    getProductStatusEnum1() {
      get(`/washcloud/storeproductcategory/findAllAsTree`, {  }).then((res) => {
          this.loading = false;
          if (res.success) {
              this.productStatusEnumList1 = res.treeData;
          }
      });
    },
    clearSubitem(id) {
      if (id == 'province') {
          this.shopStore.cityId = '';
          this.shopStore.areaId = '';
      } else if (id == 'city') {
          this.shopStore.areaId = '';
      }
    },
    getValueUser(value) {
      this.shopStore.userId = value
    },
    //上传缩略图
    uploadImage(params) {
      const file = params.file;
      let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
      if (!types.includes(file.type)) {
        this.$message.error('图片类型错误!');
      }
      const formData = new FormData();
      formData.append('file', file);
      upload(UPLOAD_PATH, formData).then((res) => {
        if (res.success) {
          this.shopStore.storeLogo = res.url;
        }
      });
    },
      //上传缩略图
      uploadImage1(params) {
          const file = params.file;
          let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
          if (!types.includes(file.type)) {
              this.$message.error('图片类型错误!');
          }
          const formData = new FormData();
          formData.append('file', file);
          upload(UPLOAD_PATH, formData).then((res) => {
              if (res.success) {
                  this.shopStore.storeBanner = res.url;
              }
          });
      },
    beforeImageUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return isLt2M;
    },
    getLocation(location){
      this.shopStore.storePosition = `${location.lng},${location.lat}`
      this.shopStore.storeAddress = location.address
      this.shopStore.provinceId = location.province
      this.shopStore.cityId = location.city
      this.shopStore.areaId = location.area
      this.shopStore.longitude = location.lng
      this.shopStore.latitude = location.lat
    },
    getTreeData() {
      get('/mpp/area/treeData').then((res) => {
        if (res.success) {
          this.areaTreeDate = res.treeData[0].children;
        }
      });
    },
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetShopStoreList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.shopStoreList = [];
    },
    resetDialog() {
      this.shopStoreState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        storeName: '', //门店名称
        storeLogo: '', //门店图片
        provinceId: '', //省
        cityId: '', //市
        areaId: '', //区
        storeAddress: '', //详细地址
        storePosition: '', //定位
        longitude: '', //经度
        latitude: '', //纬度
        openStatus: '', //营业状态
        openHours: '', //营业时间
        contactPerson: '', //联系人姓名
        contactPhone: '', //联系人电话
        remarks: '', //备注
        userId: '', //店铺管理
        createTime: '', //创建时间
      };
      this.getShopStoreList();
    },
    closeDialog() {
      this.showDialog = false
      this.shopStore = {
        id: '', //ID
        storeName: '', //门店名称
        storeLogo: '', //门店图片
        provinceId: '', //省
        cityId: '', //市
        areaId: '', //区
        storeAddress: '', //详细地址
        storePosition: '', //定位
        longitude: '', //经度
        latitude: '', //纬度
        openStatus: '', //营业状态
        openHours:['08:00:00','20:00:00'], //营业时间
        contactPerson: '', //联系人姓名
        contactPhone: '', //联系人电话
        remarks: '', //备注
        userId: '', //店铺管理
        createTime: '', //创建时间
        promoterId: '',
        personId:"",
        deliverId:"",
        sortingId:"",
        isShow: 1,
      };
    },
    submitForm() {
      if (this.shopStoreState == 'add') {
        this.$refs.shopStoreForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            this.shopStore.openHours = this.shopStore.openHours.join('-')
            post(`/washcloud/store/add`, { ...this.shopStore }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetShopStoreList();
                this.resetDialog();
              } else {
                this.shopStore.openHours = this.shopStore.openHours.split('-')
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.shopStoreState == 'edit') {
        this.$refs.shopStoreForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            let params = {...this.shopStore };
            delete params.user
            delete params.area
            delete params.city
            delete params.province
            params.openHours = params.openHours.join('-')
            console.log(params)
            post(`/washcloud/store/edit`, params ).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopStoreList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addShopStore() {
      this.showDialog = true;
      this.shopStoreState = 'add';
    },
    checkShopStore(shopStoreId) {
      console.log(shopStoreId);
      this.currentShopStoreId = shopStoreId;

      this.getShopStoreById();
      this.showDialog = true;
      this.shopStoreState = 'check';
    },
    editShopStore(shopStoreId) {
      console.log('shopStore', shopStoreId);
      if (shopStoreId) {
        this.currentShopStoreId = shopStoreId;
        this.getShopStoreById();
      } else {
        this.shopStore = { ...this.shopStore, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.shopStoreState = 'edit';
    },
    deleteShopStore(shopStoreId) {
      let ids = '';
      if (shopStoreId) {
        ids = shopStoreId;
      } else {
        ids = this.multipleSelection.map((shopStore) => shopStore.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/washcloud/store/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetShopStoreList();
              this.getShopStoreList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshShopStoreList() {
      this.resetShopStoreList();
      this.getShopStoreList();
    },
    getShopStoreList(query = {}) {
      this.loading = true;
      get(`/washcloud/store/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.shopStoreList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getShopStoreById() {
      get(`/washcloud/store/get`, { id: this.currentShopStoreId }).then((res) => {
        if (res.success) {
          this.shopStore = { ...this.shopStore, ...res.shopStore };
          this.shopStore.openHours = this.shopStore.openHours.split('-');
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportShopStoreList() {
      //this.btnLoading = true;
      exprotExcel(`/washcloud/store/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/washcloud/store/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/washcloud/store/importData`, formData);
      this.refreshShopStoreList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getShopStoreList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getShopStoreList();
    },
    currentChanges(page) {
      this.currentPages = page;
      this.openList(this.cid);
    },
    sizeChanges(size) {
      this.pageSizes = size;
      this.openList(this.cid);
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.avatar {
  width: 177px;
  height: 177px;
  display: block;
}

::v-deep .el-upload--text {
  width: 177px;
  height: 177px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .el-range-separator{
  width: 20px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 180px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>